<template>
  <div class="edit container">
    <div class="mine-box">
      <!-- 头像 -->
      <div class="edit_item">
        <div class="name">头像</div>
        <div class="right">
          <div class="message">
            <van-uploader max-count="1" v-model="fileList" multiple />
          </div>
        </div>
      </div>
      <!-- 姓名 -->
      <div class="edit_item edit_text">
        <van-field
          input-align="right"
          v-model="nick"
          label="姓名"
          placeholder="请输入姓名"
          clearable
        />
      </div>
      <div class="edit_item edit_text">
        <van-field
          input-align="right"
          v-model="address"
          label="地区"
          placeholder="请选择地区"
          @click="showAreaPopup"
          right-icon="arrow"
          readonly
        />
      </div>
    </div>
    <Button :button="button" @click.native="saveInfo" />
    <!--地区弹出层-->
    <van-popup v-model="showAreaPop" round position="bottom">
      <van-picker
        title="地区"
        show-toolbar
        value-key="name"
        :columns="region"
        @confirm="handleAreaConfirm"
        @cancel="handleAreaCancle"
      />
    </van-popup>
    <SlideBar />
  </div>
</template>

<script>
import Button from "@/components/Button";
import SlideBar from "@/components/SlideBar";
export default {
  name: "edit",
  components: {
    Button,
    SlideBar,
  },
  data() {
    return {
      nick: "",
      avatar: "",
      button: "保存信息",
      fileList: [],
      region: [],
      city: "",
      area: "",
      address: "",
      showAreaPop: false,
    };
  },

  async created() {
    this.queryRegion();
    this.queryUserInfo();
    let { data } = await this.$api.GetToken();
    let token = data;
    localStorage.setItem("uploadToken", token);
  },
  methods: {
    // 查询地区
    async queryRegion() {
      let { data } = await this.$api.queryLevelRegion();
      this.region = data;
    },
    showAreaPopup() {
      this.showAreaPop = true;
    },
    handleCancle() {
      this.showPop = false;
    },
    handleAreaCancle() {
      this.showAreaPop = false;
    },
    handleAreaConfirm(e) {
      this.address = e[0] + "·" + e[1];
      this.city = e[0];
      this.area = e[1];
      this.showAreaPop = false;
    },
    // 查询用户信息
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      this.nick = data.nick;
      this.avatar = data.avatar;
      this.fileList.push({
        url: data.avatar,
        isImage: true,
      });
      if (data.city == null) {
        this.city = "";
        this.area = "";
        this.addres = "请选择地区";
      } else {
        this.city = data.city;
        this.area = data.area;
        this.address = this.city + "·" + this.area;
      }
    },
    // 保存信息
    async saveInfo() {
      let that = this;
      if (that.fileList.length == 0) {
        that.$toast("请上传头像");
        return;
      }
      if (that.nick.trim().length === 0) {
        that.$toast("请输入姓名");
        return;
      }
      if (that.city.trim().length === 0) {
        that.$toast("请选择地区");
        return;
      }
      if (that.area.trim().length === 0) {
        that.$toast("请选择地区");
        return;
      }
      // 判断
      let imgUrlList = [];
      let avatar = "";
      if (that.fileList[0].url !== this.avatar) {
        let token = localStorage.getItem("uploadToken");
        if (that.fileList.length != 0) {
          imgUrlList = await that.$api.uploadFile(that.fileList, token);
          avatar = imgUrlList[0];
        }
      } else {
        avatar = this.avatar;
      }
      let data = {
        nick: that.nick,
        avatar: avatar,
        city: that.city,
        area: that.area,
      };
      this.$api.saveUserInfo(data);
      this.$toast("保存成功");
      setTimeout(() => {
        this.$router.push("./mine");
      }, 1000);
    },
  },
};
</script>
<style lang="scss">
.edit {
  .btn {
    width: 245px;
    height: 35px;
    span {
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss" scoped>
.edit {
  padding: 20px 20px 70px;
  box-sizing: border-box;
  .edit_name {
    /deep/.van-icon {
      color: #999999;
      font-size: 15px;
      margin-left: 5px;
    }
  }

  /deep/.van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
  }
  .mine-box {
    margin-bottom: 90px;
    .edit_item {
      width: 100%;
      height: 50px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px dashed rgba($color: #ff0000, $alpha: 0.1);
      /deep/.van-cell {
        width: 335px;
        padding: 0;
        background-color: transparent !important;
        /deep/.van-field__label {
          font-size: 14px;
          letter-spacing: 0px;
          color: #333333;
        }
        /deep/.van-field__input {
          font-size: 14px;
          letter-spacing: 0.5px;
          color: #333333;
        }
      }
      /deep/.van-cell::after {
        border-bottom: 1px solid transparent !important;
      }
      .name {
        width: 62px;
        font-size: 15px;
        letter-spacing: 0px;
        color: #333333;
        text-align: left;
      }
      .right {
        flex: 1;
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-end;
        .message {
          width: 88%;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          color: #333333;
          .picker {
            font-size: 14px;
            color: #333333;
          }
          input {
            display: block;
            width: 100%;
            height: 60px;
            line-height: 60px;
            text-align: right;
            font-size: 14px;
            color: #333333;
          }
          img {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background-color: #333333;
            float: right;
            cursor: grabbing;
            opacity: 0.8;
          }

          /deep/.van-uploader__preview-image {
            width: 50px;
            height: 50px;
            border-radius: 10px;
            border: solid 2px rgba($color: #ff0000, $alpha: 0.1);
          }
          /deep/.van-uploader__preview-delete {
            position: absolute;
            right: -4px;
            top: -4px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
          }
          /deep/.van-uploader__preview-delete-icon {
            position: absolute;
            color: #fff;
            font-size: 12px !important;
          }
          /deep/ .van-uploader__upload {
            width: 50px;
            height: 50px;
            border-radius: 10px;
          }
        }
      }
    }

    .bordernone {
      border: none;
    }
  }
}
</style>
